import { formatMoney, PaymentMethodDisplayNames, usCentsToUsd } from '@breezy/shared'
import { faOctagonExclamation } from '@fortawesome/pro-solid-svg-icons'
import React from 'react'
import { DetailRow } from '../../../../elements/StatusCard/DetailRow'
import { StatusCard } from '../../../../elements/StatusCard/StatusCard'
import type { CommonPaymentStatusProps } from './PaymentStatusCard'

export type PaymentOutcomeUnknownCardProps = CommonPaymentStatusProps

/**
 * A confirmation request reached Tilled but did not receive a terminal response. This deliberately
 * has no close/retry action: reconciliation must establish the result before another charge is tried.
 */
export const PaymentOutcomeUnknownCard = React.memo<PaymentOutcomeUnknownCardProps>(
  ({ nameOfPayer, paymentAmountUsc, paymentMethod }) => (
    <StatusCard
      type="processing"
      icon={faOctagonExclamation}
      title="Payment outcome is being confirmed"
      description="We could not verify whether this payment completed. Do not retry it while we reconcile the result."
    >
      <DetailRow label="Name of Payer" value={nameOfPayer} />
      <DetailRow label="Amount" value={formatMoney(usCentsToUsd(paymentAmountUsc))} />
      <DetailRow label="Payment Method" value={PaymentMethodDisplayNames[paymentMethod]} />
    </StatusCard>
  ),
)

PaymentOutcomeUnknownCard.displayName = 'PaymentOutcomeUnknownCard'
